
/* SELEN - BRAND SEARCH WOKIEE 3.4 - V10 */
/* Desktop + Mobil + AJAX */

(function () {
  "use strict";

  const instances = new WeakMap();
  let scheduled = false;

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase("ro-RO")
      .trim();
  }

  function installStyles() {
    if (document.getElementById("selen-brand-search-style")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "selen-brand-search-style";

    style.textContent = `
      .selen-brand-search {
        display:block;
        width:100%;
        min-width:0;
        padding:10px 12px;
        margin:10px 0 14px;
        border:1px solid #ccc;
        border-radius:4px;
        background:#fff;
        color:#171717;
        font:400 14px Montserrat,sans-serif;
        box-sizing:border-box;
      }

      .selen-brand-search:focus {
        outline:none;
        border-color:#171717;
      }

      .selen-brand-search-results {
        display:none;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:8px;
        width:100%;
        margin:10px 0 14px;
      }

      .selen-brand-search-results.is-active {
        display:grid;
      }

      .selen-brand-result {
        display:flex;
        align-items:center;
        justify-content:center;
        width:100%;
        min-width:0;
        min-height:44px;
        padding:10px 6px;
        border:1px solid #ccc;
        background:#fff;
        color:#252525;
        font:400 12px Montserrat,sans-serif;
        line-height:1.4;
        text-align:center;
        overflow-wrap:anywhere;
        cursor:pointer;
        box-sizing:border-box;
      }

      .selen-brand-result:hover {
        border-color:#171717;
      }

      .selen-brand-result.is-selected {
        background:#171717;
        color:#fff;
        border-color:#171717;
      }

      .selen-brand-search-empty {
        grid-column:1/-1;
        padding:10px 0;
        color:#777;
        font:400 12px Montserrat,sans-serif;
      }

      .selen-brand-searching
      .selen-brand-native-option {
        display:none!important;
      }

      .selen-brand-searching
      li.facets__button-show-all {
        display:none!important;
      }

      .selen-brand-searching
      show-all-facets {
        display:none!important;
      }

      /* MOBIL - DIMENSIUNE SI SPATIERE */

      .selen-brand-mobile .selen-brand-search {
        display:block;
        width:calc(100% - 20px)!important;
        max-width:none!important;
        min-height:42px;
        margin:8px 10px 32px!important;
        padding:10px 12px;
        font-size:14px;
        box-sizing:border-box;
      }

      .selen-brand-mobile .selen-brand-search-results {
        width:calc(100% - 20px);
        max-width:none;
        margin:8px 10px 20px;
        gap:8px;
        box-sizing:border-box;
      }

      @media(max-width:767px) {
        .selen-brand-mobile .selen-brand-search {
          font-size:16px;
        }

        .selen-brand-mobile .selen-brand-result {
          min-height:44px;
          font-size:12px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function isBrandDetails(details) {
    const id = normalize(details.id);

    if (id.includes("filter.p.vendor")) {
      return true;
    }

    const summary = details.querySelector(
      ":scope > summary"
    );

    if (!summary) return false;

    return normalize(summary.textContent).startsWith("brand");
  }

  function isMobile(details) {
    return normalize(details.id).includes("mobile");
  }

  function getContent(details) {
    const selectors = isMobile(details)
      ? [
          ".mobile-facets__display__content",
          ".mobile-facets__submenu",
          '[id*="FacetMobile-filter.p.vendor"]',
          ".chm-toggle__content"
        ]
      : [
          ".chm-toggle__content",
          ".facets__display",
          ".facets__display-vertical",
          ".mobile-facets__submenu"
        ];

    for (const selector of selectors) {
      const element = details.querySelector(selector);

      if (element) return element;
    }

    return null;
  }

  function getOptions(content) {
    const items = Array.from(
      content.querySelectorAll(
        'li[data-filter-type="buttons"],' +
        "li.mobile-facets__item," +
        "li.facets__item"
      )
    );

    const extra = Array.from(
      content.querySelectorAll(
        'input[name*="filter.p.vendor"]'
      )
    ).map(function (input) {
      return input.closest("li") ||
        input.closest("label");
    });

    const options = Array.from(
      new Set(items.concat(extra).filter(Boolean))
    );

    return options.filter(function (item) {
      if (item.classList.contains("facets__button-show-all")) {
        return false;
      }

      if (item.querySelector("show-all-facets")) {
        return false;
      }

      if (item.closest(".selen-brand-search-results")) {
        return false;
      }

      if (item.matches("li") && item.querySelector("li")) {
        return false;
      }

      return Boolean(
        item.querySelector(
          'label, input[type="checkbox"], button, a[href]'
        ) || item.matches("label")
      );
    });
  }

  function getName(item) {
    const label =
      item.querySelector("label") ||
      item.querySelector(".facets__label") ||
      item.querySelector(".facet-checkbox__text") ||
      item.querySelector("button") ||
      (item.matches("label") ? item : null);

    let name = label
      ? label.innerText || label.textContent
      : item.innerText || item.textContent;

    name = String(name || "")
      .replace(/\s+/g, " ")
      .trim();

    const match = name.match(/^(.+?\(\d+\))/);

    if (match) {
      return match[1].trim();
    }

    const checkbox = item.querySelector(
      'input[type="checkbox"]'
    );

    if (checkbox && checkbox.value && !name) {
      return checkbox.value.trim();
    }

    return name;
  }

  function selectOriginal(item) {
    const target =
      item.querySelector("label") ||
      item.querySelector("button") ||
      item.querySelector("a[href]") ||
      item.querySelector('input[type="checkbox"]') ||
      (item.matches("label") ? item : null);

    if (target && !target.disabled) {
      target.click();
    }
  }

  function insertSearch(details, content, input, results) {
    if (!isMobile(details)) {
      content.insertBefore(input, content.firstChild);
      input.after(results);
      return;
    }

    details.classList.add("selen-brand-mobile");

    const mobileContent = content.matches(
      ".mobile-facets__display__content"
    )
      ? content
      : content.querySelector(
          ".mobile-facets__display__content"
        );

    if (mobileContent) {
      const backButton = mobileContent.querySelector(
        ".mobile-facets__close-button"
      );

      if (backButton) {
        backButton.after(input);
        input.after(results);
        return;
      }
    }

    const backButton = content.querySelector(
      ".mobile-facets__close-button"
    );

    if (backButton) {
      backButton.after(input);
      input.after(results);
      return;
    }

    content.insertBefore(input, content.firstChild);
    input.after(results);
  }

  function initialize(details) {
    if (!isBrandDetails(details)) return;

    const content = getContent(details);
    if (!content) return;

    const previous = instances.get(details);

    if (
      previous &&
      previous.content === content &&
      previous.input.isConnected &&
      previous.results.isConnected
    ) {
      return;
    }

    details.classList.remove("selen-brand-searching");

    details.querySelectorAll(
      ".selen-brand-search, .selen-brand-search-results"
    ).forEach(function (element) {
      element.remove();
    });

    const input = document.createElement("input");

    input.type = "search";
    input.className = "selen-brand-search";
    input.placeholder = "Cauta un brand...";
    input.setAttribute("aria-label", "Cauta un brand");
    input.autocomplete = "off";

    const results = document.createElement("div");

    results.className = "selen-brand-search-results";
    results.setAttribute(
      "aria-label",
      "Rezultate cautare branduri"
    );

    insertSearch(details, content, input, results);

    instances.set(details, {
      content: content,
      input: input,
      results: results
    });

    function reset() {
      details.classList.remove("selen-brand-searching");

      content.querySelectorAll(
        ".selen-brand-native-option"
      ).forEach(function (item) {
        item.classList.remove("selen-brand-native-option");
      });

      results.classList.remove("is-active");
      results.replaceChildren();
    }

    function search() {
      const query = normalize(input.value);

      if (!query) {
        reset();
        return;
      }

      const options = getOptions(content);

      const matches = options.filter(function (item) {
        return normalize(getName(item)).includes(query);
      });

      const fragment = document.createDocumentFragment();

      matches.forEach(function (item) {
        const button = document.createElement("button");

        button.type = "button";
        button.className = "selen-brand-result";
        button.textContent = getName(item);

        const checkbox = item.querySelector(
          'input[type="checkbox"]'
        );

        if (
          (checkbox && checkbox.checked) ||
          item.querySelector('[aria-pressed="true"]') ||
          item.querySelector('[aria-selected="true"]')
        ) {
          button.classList.add("is-selected");
        }

        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          input.value = "";
          reset();

          selectOriginal(item);
        });

        fragment.appendChild(button);
      });

      if (!matches.length) {
        const empty = document.createElement("div");

        empty.className = "selen-brand-search-empty";
        empty.textContent = "Niciun brand gasit.";

        fragment.appendChild(empty);
      }

      results.replaceChildren(fragment);

      options.forEach(function (item) {
        item.classList.add("selen-brand-native-option");
      });

      details.classList.add("selen-brand-searching");
      results.classList.add("is-active");
    }

    [
      "input",
      "change",
      "keydown",
      "keyup",
      "keypress",
      "click",
      "mousedown"
    ].forEach(function (eventName) {
      input.addEventListener(eventName, function (event) {
        event.stopPropagation();
      });
    });

    input.addEventListener("input", search);

    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }

      if (event.key === "Escape") {
        event.preventDefault();
        input.value = "";
        reset();
        input.blur();
      }
    });

    details.addEventListener("toggle", function () {
      if (!details.open) {
        input.value = "";
        reset();
      }
    });
  }

  function initAll() {
    installStyles();

    document.querySelectorAll("details").forEach(
      initialize
    );
  }

  function scheduleInit() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAll
    );
  } else {
    initAll();
  }

  const observer = new MutationObserver(function (mutations) {
    const changed = mutations.some(function (mutation) {
      return mutation.type === "childList" &&
        (
          mutation.addedNodes.length > 0 ||
          mutation.removedNodes.length > 0
        );
    });

    if (changed) {
      scheduleInit();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener("toggle", scheduleInit, true);

  document.addEventListener(
    "shopify:section:load",
    scheduleInit
  );

  window.addEventListener("pageshow", scheduleInit);

})();
